<template>
    <section class="video-list">
        <div class="content">
            <MktSliceTitle :field="slice.primary.title" class="title" />
            <Swiper
                :slides-per-view="1"
                :breakpoints="{[breakpoints.mobile]: {slidesPerView: 'auto'}}"
                :space-between="40"
                :modules="MODULES"
                :navigation="true"
            >
                <SwiperSlide v-for="(video, index) in slice.items" :key="`video-${index}`" class="slide">
                    <VideoCard :video="video" />
                </SwiperSlide>
            </Swiper>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {VideoListSlice} from '@prismicio-types';
    // @ts-expect-error - swiper has no types
    import {Navigation} from 'swiper';
    import {Swiper, SwiperSlide} from 'swiper/vue';
    import {MktSliceTitle} from '#components';
    import {useRuntimeConfig} from '#imports';
    import 'swiper/css';
    import 'swiper/css/navigation';
    import VideoCard from '~/components/VideoCard.vue';

    defineProps(getSliceComponentProps<VideoListSlice>());

    const {breakpoints} = useRuntimeConfig().public;
    const MODULES = [Navigation];
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .video-list {
        overflow: hidden;

        .content {
            @include content-width($article-max-width);
        }

        .title h2 {
            margin-bottom: var(--joy-core-spacing-9);
        }

        .swiper {
            overflow: visible;
            margin-right: 40px;
            padding-bottom: 60px;

            @media (max-width: $mobile-breakpoint) {
                margin-right: 0;
            }
        }

        .swiper-wrapper {
            overflow: visible;
        }

        .slide {
            width: auto;

            @media (max-width: $mobile-breakpoint) {
                width: 100%;
            }
        }

        .swiper-button-prev,
        .swiper-button-next {
            content: url('~/assets/svg/arrowRight.svg');
            padding: var(--joy-core-spacing-3);
            border-radius: var(--joy-core-radius-6);
            height: 42px;
            width: 42px;
            background-color: var(--joy-color-primary-50);
            position: absolute;
            top: unset;
            bottom: 10px;
            left: unset;
            right: 0;
        }

        .swiper-button-prev {
            transform: rotate(180deg);
            left: unset;
            right: 60px;
        }
    }
</style>
